/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Billing_No_Payment_MethodInputs */



/**
* | output |
* | --- |
* | "No payment method on file" |
*
* @param {Sub_Billing_No_Payment_MethodInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_billing_no_payment_method = /** @type {((inputs?: Sub_Billing_No_Payment_MethodInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Billing_No_Payment_MethodInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Zahlungsmethode hinterlegt")
	return /** @type {LocalizedString} */ ("No payment method on file")
});